// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"Form_submitButton__R3Yhw","form":"Form_form__3Rm4l"};